__turbopack_context__.v({
  "category_name": "K_HayW_category_name",
  "item": "K_HayW_item",
  "item_icon": "K_HayW_item_icon",
  "item_info": "K_HayW_item_info",
  "item_info_legal_entity": "K_HayW_item_info_legal_entity",
  "item_info_meta": "K_HayW_item_info_meta",
  "item_info_name": "K_HayW_item_info_name",
  "item_info_note": "K_HayW_item_info_note",
  "item_info_organization": "K_HayW_item_info_organization",
  "item_info_organization_url": "K_HayW_item_info_organization_url",
  "item_info_tags": "K_HayW_item_info_tags",
  "item_monogram": "K_HayW_item_monogram",
  "list": "K_HayW_list",
  "title": "K_HayW_title",
});
